/**
 * mSTEM tutorial modal reducer (PRJ-06 + PRJ-07 / LLD UC 09-10).
 *
 * Tracks which tutorial deck (`'ide'` or `'firmware'`) is currently shown
 * inside MstemTutorialModal and which chapter is selected in the
 * master-detail sidebar. The pure reducer only setters — prev/next
 * navigation is implemented in the container by computing the neighbor
 * chapter id from the loaded chapter list and dispatching
 * `setActiveChapter`.
 */

const OPEN = 'scratch-gui/tutorial-modal/OPEN';
const SET_ACTIVE = 'scratch-gui/tutorial-modal/SET_ACTIVE';
const CLOSE = 'scratch-gui/tutorial-modal/CLOSE';
// NEXT/PREV are no-ops in the reducer (handled in the container, which
// computes the neighbor chapter id from the loaded chapters list and
// dispatches setActiveChapter). They're declared as proper action types so
// the container can compose them via thunk middleware later without
// re-litigating the namespace.
const NEXT = 'scratch-gui/tutorial-modal/NEXT';
const PREV = 'scratch-gui/tutorial-modal/PREV';

const initialState = {
    type: null, // 'ide' | 'firmware' | null
    activeChapterId: null
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN:
        if (action.tutorialType !== 'ide' && action.tutorialType !== 'firmware') return state;
        return Object.assign({}, state, {
            type: action.tutorialType,
            activeChapterId: typeof action.chapterId === 'string' ? action.chapterId : null
        });
    case SET_ACTIVE:
        if (typeof action.chapterId !== 'string') return state;
        return Object.assign({}, state, {activeChapterId: action.chapterId});
    case CLOSE:
        return Object.assign({}, state, {type: null, activeChapterId: null});
    default:
        return state;
    }
};

const openTutorial = function (tutorialType, chapterId) {
    return {type: OPEN, tutorialType: tutorialType, chapterId: chapterId};
};
const setActiveChapter = function (chapterId) {
    return {type: SET_ACTIVE, chapterId: chapterId};
};
const closeTutorial = function () {
    return {type: CLOSE};
};
// Wave 1 containers will compose these with the loaded chapter list to
// compute the neighbor id, then dispatch setActiveChapter. The pure
// reducer treats them as no-ops so unit tests can assert "no state
// mutation on NEXT/PREV".
const nextChapter = function () {
    return {type: NEXT};
};
const prevChapter = function () {
    return {type: PREV};
};

export {
    reducer as default,
    initialState as tutorialModalInitialState,
    openTutorial,
    setActiveChapter,
    closeTutorial,
    nextChapter,
    prevChapter
};
